<template>
  <div class="hello">
    <sui-button floated="left" content="Back" icon="backward" @click="$router.go(-1)" />
    <sui-button floated="right" content="Refresh" icon="refresh" v-on:click="refresh()" />
    <div v-if="device">
        <h1>Device {{ device.deviceId }}</h1>
        
        <sui-grid>
            <sui-grid-row>
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Data</h3>
                    <sui-segment attached>
                        
                        <ListHistory :deviceId="device.deviceId" />
                    </sui-segment>
                </sui-grid-column>
            </sui-grid-row>
            <sui-grid-row :columns="2">
                <sui-grid-column>
                    
                    <h3 is="sui-header" attached="top"><sui-button floated="right" content="Go to channel" icon="eye" v-on:click="$router.push({ name: 'alias_detail', params: { id: device.alias } })" size="mini" />Channel</h3>
                    
                    <sui-segment attached>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras arcu massa, molestie luctus diam non, aliquam dignissim nisi. Nullam ac dui nec massa viverra sollicitudin eget nec urna. Nunc ac maximus dolor.</p>
                        <AliasInlineEditor :alias="device.alias" :deviceId="device.deviceId" />
                    </sui-segment>
                </sui-grid-column>
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Deactivate</h3>
                    <sui-segment attached>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras arcu massa, molestie luctus diam non, aliquam dignissim nisi. Nullam ac dui nec massa viverra sollicitudin eget nec urna. Nunc ac maximus dolor.</p>
                        <sui-message v-if="unauthorizeError" color="red">
                          <sui-message-header>Deactivation error</sui-message-header>
                          <p>
                            {{ unauthorizeError }}
                          </p>
                        </sui-message>
                        <sui-button content="Deactivate device" icon="close" negative v-on:click="deactivateDevice()" :loading="deactivating ? true : false" :disabled="deactivating ? true : false" />    
                    </sui-segment>
                </sui-grid-column>
            </sui-grid-row>
        </sui-grid>
        
        
    </div>
    <div v-else>
        <h1>...</h1>
    </div>
    
    
  </div>
</template>

<script>
import DziService from '@/DziService'
import AliasInlineEditor from '@/components/Device/AliasInlineEditor.vue';
import ListHistory from '@/components/Device/ListHistory.vue';


export default {
  name: 'DeviceDetail',
  data () {
        return {
            device: null,
            unauthorizeError: null,
            deactivating: false
        }
    },  
  props: {
//    msg: String
  },
  methods: {
        refresh() {
          this.device = null;
          this.getDevice();  
        },
        async getDevice () {
            const response = await DziService.getDevice(this.$route.params.id)
            this.device = response.data;
        },
        async deactivateDevice () {
            this.deactivating = true;
            this.unauthorizeError = null;
            const response = await DziService.deactivateDevice(this.$route.params.id)
            
            if (response.error)
            {
                this.unauthorizeError = response.error;
                this.deactivating = false;
            }
            else if (response.status == 'ok')
            {
                this.$store.commit('resetDevices');
                this.$router.push({'name': 'device_list'})
            }
                
        },
    },
    mounted () {
        this.getDevice();
        },
        components: {
            AliasInlineEditor,
            ListHistory
        }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
